import { useEffect, useState } from "react";
import { Download, Folder, FileDown } from "lucide-react";
import { api } from "../../lib/api";
import { useBrand } from "../../contexts/BrandContext";
import SEO from "../../components/SEO";
import { downloadAction } from "../../lib/downloads";

export default function FirmwarePage() {
  const { mode, brand } = useBrand();
  const [items, setItems] = useState([]);
  const [openGroups, setOpenGroups] = useState({});

  useEffect(() => {
    const params = new URLSearchParams();
    if (mode === "brand" && brand) params.set("brand_slug", brand.slug);
    params.set("type", "firmware");
    api.get(`/downloads?${params.toString()}`).then((r) => {
      setItems(r.data);
      // expand all by default
      const groups = {};
      r.data.forEach((d) => { groups[d.group || "Diğer"] = true; });
      setOpenGroups(groups);
    });
  }, [mode, brand]);

  const grouped = items.reduce((acc, it) => {
    const g = it.group || "Diğer";
    acc[g] = acc[g] || [];
    acc[g].push(it);
    return acc;
  }, {});

  return (
    <div className="fade-in-up" data-testid="firmware-page">
      <SEO title="Firmware" />
      <div className="border-b border-white/10 py-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-3">Destek</div>
          <h1 className="font-display text-4xl sm:text-5xl tracking-tighter">Firmware</h1>
          <p className="mt-4 text-zinc-400 max-w-2xl">Ürünleriniz için güncel firmware dosyalarını indirebilirsiniz.</p>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {items.length === 0 ? (
          <div className="text-center py-20 text-zinc-500" data-testid="firmware-empty">
            Henüz firmware dosyası eklenmemiş.
          </div>
        ) : (
          <div className="border border-white/10 bg-[#0A0A0A] font-mono text-sm" data-testid="firmware-tree">
            {Object.entries(grouped).map(([group, list]) => {
              const open = openGroups[group];
              return (
                <div key={group} className="border-b border-white/5 last:border-b-0">
                  <button
                    onClick={() => setOpenGroups({ ...openGroups, [group]: !open })}
                    className="w-full flex items-center gap-2 px-4 py-3 hover:bg-white/5 text-left"
                    data-testid={`firmware-group-${group}`}
                  >
                    <Folder size={14} className="text-zinc-500" />
                    <span className="text-zinc-200">{group}</span>
                    <span className="text-xs text-zinc-500 ml-auto">{list.length} dosya</span>
                  </button>
                  {open && (
                    <div className="bg-[#080808]">
                      {list.map((d) => (
                        <button
                          key={d.id}
                          onClick={() => downloadAction(d)}
                          className="w-full flex items-center gap-3 px-4 py-3 pl-10 hover:bg-white/5 text-left border-t border-white/5"
                          data-testid={`firmware-item-${d.id}`}
                        >
                          <FileDown size={14} className="text-zinc-500 shrink-0" />
                          <span className="text-zinc-200 truncate flex-1">{d.title}</span>
                          {d.version && (
                            <span className="text-xs text-zinc-500 px-2 py-0.5 border border-white/10">{d.version}</span>
                          )}
                          <Download size={14} className="text-zinc-400 shrink-0" />
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
